import React from 'react'
import styled from 'styled-components'
import { customHexForVideo } from '../constants'
import { mobile } from 'shared/util/media-query'

const AdGridContainer = styled.section`
    width: 100%;
`

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${customHexForVideo};

    img {
        width: 112px;
    }

    p {
        text-align: center;
        line-height: 30px;
        width: 573px;
    }

    ${mobile.css`
        p {
            width: 100%;
        }

    `}
`

const Content = styled.div`
    display: flex;
    flex-direction: column;

    video {
        width: 100%;

        ${mobile.css`
            width: unset;
            height: 516px;
            object-fit: cover;
        `}
    }

    ${mobile.css`
        width: 100%;
        margin: auto;
        flex-direction: column-reverse;
    `}
`

const AdGrid = () => {
    return (
        <AdGridContainer>
            <Header>
                <img src={'/static/img/giphy-marketers/hair-flip.gif'} />
                <h1>Campaign&rsquo;d Content</h1>
                <p>
                    Enough talk, here&rsquo;s just a few of the campaigns that we&rsquo;ve partnered with and brought to
                    life.
                </p>
            </Header>
            <Content>
                <video autoPlay loop muted playsInline>
                    <source src={'/static/img/giphy-marketers/giphy-adgrid_web_compressed.mp4'} type="video/mp4" />
                </video>
            </Content>
        </AdGridContainer>
    )
}

export default AdGrid
